import React from 'react'

const ScanItemsIcon = ({ color = 'white', style, ...props }) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0, ...style }}
    {...props}
  >
    <path
      d="M10.7305 22.2109V10.7305H9.47852V22.2109H10.7305ZM13.9502 22.2109V10.7305H12.6982V22.2109H13.9502ZM17.1699 22.2109V10.7305H15.918V22.2109H17.1699ZM22.0459 22.2109V10.7305H19.542V22.2109H22.0459ZM27.7715 22.2109V10.7305H23.5986V22.2109H27.7715ZM30.6611 22.2109V10.7305H29.4092V22.2109H30.6611ZM35.1465 22.2109V10.7305H32.6426V22.2109H35.1465ZM38.3799 22.2109V10.7305H37.1279V22.2109H38.3799ZM38.3799 24.7861H37.1279V36.2666H38.3799V24.7861ZM35.1465 24.7861H32.6426V36.2666H35.1465V24.7861ZM30.6611 24.7861H29.4092V36.2666H30.6611V24.7861ZM27.7715 24.7861H23.5986V36.2666H27.7715V24.7861ZM22.0459 24.7861H19.542V36.2666H22.0459V24.7861ZM17.1699 24.7861H15.918V36.2666H17.1699V24.7861ZM13.9502 24.7861H12.6982V36.2666H13.9502V24.7861ZM10.7305 24.7861H9.47852V36.2666H10.7305V24.7861Z"
      fill={color}
    />
  </svg>
)

export default ScanItemsIcon
